/**
 * User permission
 */
export class UserRight {
  /**
   * Module
   */
  module: string;

  /**
   * Right
   */
  right: string;

  /**
   * Enabled
   */
  enabled: boolean;

  /**
   * Create from JSON
   *
   * @param json Object
   *
   * @returns UserPermission instance
   */
  static createFromJson(json: object): UserRight {
    const self = new UserRight();
    Object.keys(json).forEach((key) => {
      // TODO Return boolean from backend
      if (key === 'option') {
        self.enabled = typeof json[key] === 'string' ? json[key].toUpperCase() === 'SI' : typeof json[key] === 'boolean' ? json[key] : false;
      } else {
        self[key] = json[key];
      }
    });
    return self;
  }
}

/**
 * User
 */
export class LoginUser {
  /**
   * Name
   */
  name: string;

  /**
   * Language
   */
  language: string;

  /**
   * Permissions array
   */
  rights: UserRight[] = [];

  /**
   * Create from JSON
   *
   * @param json object
   *
   * @returns User instance
   */
  static createFromJson(json: object): LoginUser {
    const self = new this();
    Object.keys(json).forEach((key) => {
      if (key === 'rights' && Array.isArray(json[key])) {
        json[key].forEach((permission) => {
          self.rights.push(UserRight.createFromJson(permission));
        });
      } else {
        self[key] = json[key];
      }
    });
    return self;
  }
}
